import { useEffect } from 'react'
import axios from './../../utils/axios'
import { CancelToken } from 'axios'
import { SALES_EMAIL } from './../../constants'

const usePropertyContact = (company, property, setContacts) => {
  useEffect(() => {
    let source = CancelToken.source()
    const fetchProperty = async () => {
      try {
        const result = await axios.get(`/public/properties/${encodeURIComponent(company)}/${encodeURIComponent(property)}`, { cancelToken: source.token })
        if (result.data.errors) return
        const _contacts = result.data.record.property_contacts
        let returnContacts
        // If ID360 Property Contact not found, search company contacts
        if (!_contacts || _contacts.length === 0) {
          returnContacts = await getCompanyContacts()
        } else {
          const propertyEmails = _contacts.map(contact => contact.email).filter(email => email)
          returnContacts = propertyEmails.length > 0 ? propertyEmails : await getCompanyContacts()
        }
        setContacts(returnContacts)
      } catch (e) {
        console.warn('Unable to fetch property contacts', e)
      }
    }

    const getCompanyContacts = async () => {
      try {
        const result = await axios.get(`/public/companies/${encodeURIComponent(company)}`, { cancelToken: source.token })
        if (result.data.errors) return []
        const companyContacts = result.data.record.contacts
        // Check if leasing management email exists, if not use the Sales email
        if (companyContacts?.leasing_management_email) {
          return [companyContacts.leasing_management_email]
        } else return [SALES_EMAIL]
      } catch (e) {
        console.warn('Unable to get company info', e)
      }
    }

    if (!company || !property) return null
    fetchProperty()

    return () => {
      source.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company, property])
}

export { usePropertyContact }